import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Building2, QrCode, ArrowRight } from "lucide-react";

export default function SecuritySummary() {
  return (
    <section className="border-t border-zinc-100" data-testid="security-summary-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-5">Seguridad</p>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-900 leading-tight">
            Privado por diseño.
          </h2>
          <p className="text-lg text-zinc-600 leading-relaxed mt-5">
            La información de cada empresa está aislada y solo es accesible por sus usuarios
            autorizados. Los QR nunca hacen pública una máquina: escanear exige autenticación y
            pertenecer a la empresa correspondiente.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-8">
            <div className="flex items-center gap-3 text-sm text-zinc-600">
              <Building2 size={16} className="text-zinc-400" />
              Aislamiento multiempresa verificado en servidor
            </div>
            <div className="flex items-center gap-3 text-sm text-zinc-600">
              <QrCode size={16} className="text-zinc-400" />
              QR → autenticación → autorización → máquina
            </div>
          </div>
          <Link
            to="/security"
            data-testid="security-summary-link"
            className="inline-flex items-center gap-2 mt-8 text-sm font-medium text-zinc-900 underline underline-offset-4 hover:text-zinc-600 transition-colors"
          >
            Ver cómo protegemos la información <ArrowRight size={14} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
